import { render, staticRenderFns } from "./Superuser.vue?vue&type=template&id=17362a2e&"
import script from "./Superuser.vue?vue&type=script&lang=js&"
export * from "./Superuser.vue?vue&type=script&lang=js&"
import style0 from "./Superuser.vue?vue&type=style&index=0&id=17362a2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports